import React from "react";
import { CN_NOTIFY_EVENT_TYPE } from "@/services/print/client/cainiaoPrintAgentClient";
import { DY_NOTIFY_EVENT_TYPE } from "@/services/print/client/jinritemaiPrintAgentClient";
import { PDD_NOTIFY_EVENT_TYPE } from "@/services/print/client/pddPrintAgentClient";
import { KWAI_NOTIFY_EVENT_TYPE } from "@/services/print/client/kwaiPrintAgentClient";
import {
    NotifyPrintResultResponseData,
    TaskStatus as CN_TaskStatus,
} from "@/services/print/client/types/cainiao/api/notifyPrintResult";
import { JinritemaiNotifyPrintResultResponse } from "@/services/print/client/types/jinritemai/api/JinritemaiNotifyPrintResult";
import {
    PrintResultNotifyResponseData,
    TaskStatus as PDD_TaskStatus,
} from "@/services/print/client/types/pdd/api/printResultNotify";

import DY_TaskStatusEnum from "@/services/print/client/types/jinritemai/enum/TaskStatusEnum";
import { KWaiNotifyPrintResultResponse } from "@/services/print/client/types/KWai/api/KWaiNotifyPrintResult";
import { LoggerInfoTag, postLogInfo } from "@/services/api/log";

let instance: WaybillPrinterLogStore;

class WaybillPrinterLogStore {
    constructor() {
        if (instance) {
            return instance;
        }

        instance = this;

        this.init();

        return instance;
    }

    init() {
        window.addEventListener(CN_NOTIFY_EVENT_TYPE, this.cnNotifyCallback);
        window.addEventListener(DY_NOTIFY_EVENT_TYPE, this.dyNotifyCallback);
        window.addEventListener(PDD_NOTIFY_EVENT_TYPE, this.pddNotifyCallback);
        window.addEventListener(KWAI_NOTIFY_EVENT_TYPE, this.ksNotifyCallback);
    }

    dispose = () => {
        window.removeEventListener(CN_NOTIFY_EVENT_TYPE, this.cnNotifyCallback);
        window.removeEventListener(DY_NOTIFY_EVENT_TYPE, this.dyNotifyCallback);
        window.removeEventListener(PDD_NOTIFY_EVENT_TYPE, this.pddNotifyCallback);
        window.removeEventListener(KWAI_NOTIFY_EVENT_TYPE, this.ksNotifyCallback);
    };

    cnNotifyCallback = async (event: Event) => {
        const data = event?.["data"] as NotifyPrintResultResponseData;

        const taskId = data?.taskID;

        if (!taskId) {
            return;
        }
        if (data?.taskStatus === CN_TaskStatus.FAILED) {
            postLogInfo({
                tag: LoggerInfoTag.CN_PRINTER_ERROR,
                content: JSON.stringify(data),
            });
        }
    };

    dyNotifyCallback = async (event: Event) => {
        const data = event["data"] as JinritemaiNotifyPrintResultResponse;

        const taskId = data?.taskID;

        if (!taskId) {
            return;
        }

        if (data?.taskStatus === DY_TaskStatusEnum.FAILED) {
            postLogInfo({
                tag: LoggerInfoTag.DY_PRINTER_ERROR,
                content: JSON.stringify(data),
            });
        }
    };

    pddNotifyCallback = async (event: Event) => {
        const data = event["data"] as PrintResultNotifyResponseData;

        const taskId = data?.taskID;

        if (!taskId) {
            return;
        }

        if (data?.taskStatus === PDD_TaskStatus.FAILED) {
            postLogInfo({
                tag: LoggerInfoTag.PDD_PRINTER_ERROR,
                content: JSON.stringify(data),
            });
        }
    };

    ksNotifyCallback = async (event: Event) => {
        const data = event["data"] as KWaiNotifyPrintResultResponse;

        const taskId = data?.taskID;

        if (!taskId) {
            return;
        }
        if (data?.taskStatus === "failed") {
            postLogInfo({
                tag: LoggerInfoTag.KS_PRINTER_ERROR,
                content: JSON.stringify(data),
            });
        }
    };
}

export default WaybillPrinterLogStore;
